import { id } from "date-fns/locale";
import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import MaskInput from "../../../../components/inputs/mask";
import TextInput from "../../../../components/inputs/text";
import Loading from "../../../../components/loading";
import libForm from "../../../../util/libForm";
import InstanceCard from "./card";
import { IndexHook } from "./hooks";
import { ToastContainer } from "react-toastify";
import { ArrowRightCircle } from "lucide-react";

const FormWhatsApp = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	setLoading,
	fetchID,
	reloadData,
	reloadFetchFirstData,
	insert,
	deleteItemCard,
}) => {
	const {
		//useForm
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,

		instancia,
		telefone,
		id_whatsapp,

		loading, //formState
		errors,
		isSubmitting,
		handleOnError,

		handleCloseModalRegister,
		handleOnSubmit,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		setLoading,
		fetchID,
		reloadData,
		reloadFetchFirstData,
		insert,
	});

	const deleted = async (id_whatsapp) => {
		deleteItemCard(id_whatsapp);
		handleCloseModalRegister();
	};

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Aguarde buscando dados no servidor..." />
				</div>
			) : (
				<form className="form" onSubmit={handleSubmit(handleOnSubmit, handleOnError)}>
					<main>
						<div className="row">
							{id_whatsapp === 0 ? (
								<>
									<TextInput
										label="Digite o nome da instância"
										id="descricao"
										placeholder=""
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										className="col-12 col-sm-7 col-lg-7"
										autoFocus={true}
									/>
									{/* <button
										onClick={handleGenerateQR}
										disabled={loading}
										className={`w-full h-8 flex items-center justify-center gap-2 bg-yellow-600 text-white py-2 rounded-lg shadow-md hover:bg-yellow-700 transition`}
										// className={`w-full flex items-center justify-center gap-2 bg-yellow-100 text-yellow-700 py-2 rounded-md hover:bg-yellow-200 transition ${
										// 	loading && "opacity-50 cursor-not-allowed"
										// }`}
									>
										<ArrowRightCircle size={16} />

										{"Próximo"}
									</button> */}
									{/* <MaskInput
										label="Celular"
										name="telefone"
										control={control}
										errors={errors}
										required={false}
										format="(##)#####-####"
										className="col-6 col-sm-3 col-lg-2"
										onKeyDown={libForm.EnterTab}
										// setFocus={setFocus}
									/> */}
								</>
							) : (
								<div className="px-4 w-60">
									<InstanceCard
										instanceName={instancia}
										instancePhone={telefone}
										onDelete={() => deleted(id_whatsapp)}
									/>
								</div>
							)}
						</div>
					</main>
					{id_whatsapp === 0 && (
						<footer>
							<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
							<BtnSubmit isSubmitting={isSubmitting} />
						</footer>
					)}
				</form>
			)}
		</>
	);
};

export default FormWhatsApp;
